import Vuex from 'vuex';
import Vue from 'vue';
// Modules
import { wp, api } from '@/utils/client';
import login from './modules/login';
import notification from './modules/notification';
import product from './modules/product';
import giftBoxCampaign from './modules/giftBoxCampaign';
import singleEventCampaign from './modules/singleEventCampaign';
import team from './modules/team';
import term from './modules/term';
import transaction from './modules/transaction';
import paymentDocument from './modules/paymentDocument';
import resources from './modules/resources';
import tutorials from './modules/tutorials';
import warehouse from './modules/warehouse';
import oms from './modules/oms';
import surveys from './modules/surveys';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    headLoaded: false,
    coreLoaded: false,
    currentUser: { id:  null, name: null, team_name: null, logo_url: null, permissions: [] },
    currentUserTeams: [],
    teamId: parseInt(localStorage.getItem('selectedTeam')),
    gbPageUrlBase: 'pick-a-gift',
    sidebarBP: 1135,
    sidebarDisplayed: (window.innerWidth <= 1135),
    sidebarShown: false,
    sidebarMode: localStorage.getItem('wsSidebarMode') || 'full',
    notecard_price: 1.2,
    notecard_price_exc_vat: 1,
    

    demo: {
        isDemo:  new URL(location.href).pathname.split('/')[1] == 'demo',
        teamId: 132,
        userId: 107348,
        loginEmail: 'manager@namco.com',
        loginPassword: 'demopassword',
    },
    proBlockMessage: '',
    platform: new URL(location.href).pathname.split('/')[1],

    contactModalOptions: [
        {id: 'new-team-request', name: 'New team request', locations: ['login'], type: 'high-level'},
        {id: 'login-issue', name: 'Login issue', locations: ['login'], type: 'support'},
        {id: 'general', name: 'General query', locations: ['app','login'], type: 'manager'},
        {id: 'gifting', name: 'Gifting campaign request', locations: ['app'], type: 'manager'},
        {id: 'voucher', name: 'Voucher campaign request', locations: ['app'], type: 'manager'},
        {id: 'product', name: 'Product request', locations: ['app'], type: 'manager'},
        {id: 'payment', name: 'Financial issue', locations: ['app'], type: 'support'},
        {id: 'account', name: 'Account or team issue', locations: ['app'], type: 'support'},
        {id: 'pro-upgrade', name: 'Bookblock HUB Pro upgrade', locations: ['login','app'], type: 'high-level'},
        {id: 'bug', name: 'Bug report', locations: ['app'], type: 'techical'},
        {id: 'other', name: 'Other issue', locations: ['app','login'], type: 'support'},
    ],
    contactModalConfig: {location: 'app', subject: null},

    modals: {
      contactModal: false,
      editGiftBoxCampaign: false,
      editGiftBoxRegistration: false,
      giftBoxCampaignsInvite: false,
      giftRegistrationModal: false,
      giftRegistrationModalEdit: false,
      giftRegistrationNoteModal: false,
      giftBoxCampaignsMultiModal:false,
      giftInviteModal:false,
      productRequestsCreate:false, productRequestsEdit: false,
      productRestock: false,
      productEdit: false,
      giftBoxCampaignsOptionEdit: false,
      giftBoxCampaignsOptionCreate: false,
      billingTopUpModal: false,
      transactionHistoryExportModal: false,
      paymentDocumentRequestModal: false,
      userSettings: false,
      teamSwitcher: false,
      notecardModal: false,
      paymentMethodModal: false,
      marketplaceProductModal: false,
	  marketplaceTutorialModal: false,
      batchDetailModal: false,
      campaignIntegrationsModal: false,
      apiKeyModal: false,
      productAllocation: false,
      dateRangeModal: false,
      feedbackModal: false,
      registrationModal: false, 
      whRequestModal: false, 
      importWHOrdersModal: false, 
      fulfilmentExportModal: false,
      omsEnquiryModal: false,
    },

    permissionsList: [
        {
            'slug' : 'use-balance',
            'name' : 'Use Team Balance',
            'text' : 'Enable this team member to use shared team balance (and team credit, if available) for Gift Campaign and Marketplace payments.',
            'default' : {'manager' : true, 'associate' : true},
        }, {
            'slug' : 'use-cards',
            'name' : 'Use Payment Cards',
            'text' : 'Enable this team member to use their own credit or debit card for direct payments in Gift Campaings and Marketplace.',
            'default' : {'manager' : true, 'associate' : true},
        }, {
            'slug' : 'view-others-orders',
            'name' : 'Access Other Team Member Orders',
            'text' : 'Enable this team member to see and manage orders of other team members in Gift Campaings and Marketplace.',
            'default' : {'manager' : true, 'associate' : true},
        }, {
            'slug' : 'team-finance',
            'name' : 'Full Billing & Payment Access',
            'text' : 'Enable this team member to request team balance top ups, view full team transaction history and access the payment documents.',
            'default' : {'manager' : true, 'associate' : true},
        }, {
            'slug' : 'edit-team-members',
            'name' : 'Add, Edit & Delete Team Members',
            'text' : 'Enable this team member to add new team members and to edit current team members and their permissions.',
            'default' : {'manager' : true, 'associate' : false},
        }, {
            'slug' : 'edit-team-settings',
            'name' : 'View & Edit Team Settings & Integrations',
            'text' : 'Enable this team member to manage your team settings on team settings page and to manage external integrations.',
            'default' : {'manager' : true, 'associate' : false},
        }
    ],

    emailCategories: [
      {type: 'gifting-campaign', label: 'Gifting Campaign Updates'},
      {type: 'gifting-campaign-registration', label: 'Campaign Page Gift Registration Notices'},
      {type: 'product', label: 'Product Updates'},
      {type: 'product-allocation', label: 'Product Allocation Notices'},
      {type: 'billing', label: 'Billing & Payment Notices'},
      {type: 'billing-credit', label: 'Out Of Credit Notices'},
    ],

    giftRegistrationMethods: [
      {type: 'direct', label: 'Select & Send'},
      {type: 'link', label: 'Invitation'},
      {type: 'multiple', label: 'Multi Send'},
      {type: 'multiple-link', label: 'Multi Invite'},
      //{type: 'email', label: 'Email Invite'},
      {type: 'public', label: 'Public Page'},
      {type: 'external', label: 'CRM'},
      {type: 'unknown', label: 'Other / Unknown'},
    ],

      giftFulfillmentStatus: [
          //{status: 'processing', label: 'Processing'},
          //{status: 'sent', label: 'Sent'},
          {status: 'return', label: 'Returned'},
      ],


      giftOptionTypes: [
      {text: 'Physical Gift Box', value: 'physical'},
      {text: 'Digital Voucher', value: 'voucher'},
    ],

    voucherCategories: [
        {text: 'Food & Drink', value: 'food-and-drink'},
        {text: 'Fashion', value: 'fashion'},
        {text: 'Travel & Leisure', value: 'travel-and-leisure'},
        {text: 'Home', value: 'home'},
        {text: 'Books', value: 'books'},
        {text: 'Electronics', value: 'electronics'},
        {text: 'Music', value: 'music'},
        {text: 'TV & Movies', value: 'tv-and-movies'},
    ],

    privacyLevels: {
      'invite': 'Private',
      'internal': 'Internal', // legacy
      'public': 'Open'
    }, 
      
     surveyTypes: [
          {value: 'research', text: 'Research'},
          {value: 'feedback', text: 'Feedback'},
          {value: 'lead', text: 'Lead Capture'},
          {value: 'registration', text: 'Registration'},
          {value: 'demographics', text: 'Demographics'},
          {value: 'event', text: 'Event'},
          {value: 'orientation', text: 'Orientation'},
          {value: 'other', text: 'Other'},
      ],
      
      surveyThemeSamplePage: {
          title: 'Preview of page title.', 
          subtitle: 'This is your page subtitle.',
          button_text: 'Start',
          type: 'welcome',
      },
      
      surveyThemeSamplePageSmall: {
          title: 'Your Page Title.',
          subtitle: 'Your page subtitle.',
          button_text: 'Start',
          type: 'welcome'
      },

    isoCountries: [
      {value: 'AF', text: 'Afghanistan'},
      {value: 'AX', text: 'Aland Islands'},
      {value: 'AL', text: 'Albania'},
      {value: 'DZ', text: 'Algeria'},
      {value: 'AS', text: 'American Samoa'},
      {value: 'AD', text: 'Andorra'},
      {value: 'AO', text: 'Angola'},
      {value: 'AI', text: 'Anguilla'},
      {value: 'AQ', text: 'Antarctica'},
      {value: 'AG', text: 'Antigua And Barbuda'},
      {value: 'AR', text: 'Argentina'},
      {value: 'AM', text: 'Armenia'},
      {value: 'AW', text: 'Aruba'},
      {value: 'AU', text: 'Australia'},
      {value: 'AT', text: 'Austria'},
      {value: 'AZ', text: 'Azerbaijan'},
      {value: 'BS', text: 'Bahamas'},
      {value: 'BH', text: 'Bahrain'},
      {value: 'BD', text: 'Bangladesh'},
      {value: 'BB', text: 'Barbados'},
      {value: 'BY', text: 'Belarus'},
      {value: 'BE', text: 'Belgium'},
      {value: 'BZ', text: 'Belize'},
      {value: 'BJ', text: 'Benin'},
      {value: 'BM', text: 'Bermuda'},
      {value: 'BT', text: 'Bhutan'},
      {value: 'BO', text: 'Bolivia'},
      {value: 'BA', text: 'Bosnia And Herzegovina'},
      {value: 'BW', text: 'Botswana'},
      {value: 'BV', text: 'Bouvet Island'},
      {value: 'BR', text: 'Brazil'},
      {value: 'IO', text: 'British Indian Ocean Territory'},
      {value: 'BN', text: 'Brunei Darussalam'},
      {value: 'BG', text: 'Bulgaria'},
      {value: 'BF', text: 'Burkina Faso'},
      {value: 'BI', text: 'Burundi'},
      {value: 'KH', text: 'Cambodia'},
      {value: 'CM', text: 'Cameroon'},
      {value: 'CA', text: 'Canada'},
      {value: 'CV', text: 'Cape Verde'},
      {value: 'KY', text: 'Cayman Islands'},
      {value: 'CF', text: 'Central African Republic'},
      {value: 'TD', text: 'Chad'},
      {value: 'CL', text: 'Chile'},
      {value: 'CN', text: 'China'},
      {value: 'CX', text: 'Christmas Island'},
      {value: 'CC', text: 'Cocos (Keeling) Islands'},
      {value: 'CO', text: 'Colombia'},
      {value: 'KM', text: 'Comoros'},
      {value: 'CG', text: 'Congo'},
      {value: 'CD', text: 'Congo, Democratic Republic'},
      {value: 'CK', text: 'Cook Islands'},
      {value: 'CR', text: 'Costa Rica'},
      {value: 'CI', text: 'Cote D\'Ivoire'},
      {value: 'HR', text: 'Croatia'},
      {value: 'CU', text: 'Cuba'},
      {value: 'CY', text: 'Cyprus'},
      {value: 'CZ', text: 'Czech Republic'},
      {value: 'DK', text: 'Denmark'},
      {value: 'DJ', text: 'Djibouti'},
      {value: 'DM', text: 'Dominica'},
      {value: 'DO', text: 'Dominican Republic'},
      {value: 'EC', text: 'Ecuador'},
      {value: 'EG', text: 'Egypt'},
      {value: 'SV', text: 'El Salvador'},
      {value: 'GQ', text: 'Equatorial Guinea'},
      {value: 'ER', text: 'Eritrea'},
      {value: 'EE', text: 'Estonia'},
      {value: 'ET', text: 'Ethiopia'},
      {value: 'FK', text: 'Falkland Islands (Malvinas)'},
      {value: 'FO', text: 'Faroe Islands'},
      {value: 'FJ', text: 'Fiji'},
      {value: 'FI', text: 'Finland'},
      {value: 'FR', text: 'France'},
      {value: 'GF', text: 'French Guiana'},
      {value: 'PF', text: 'French Polynesia'},
      {value: 'TF', text: 'French Southern Territories'},
      {value: 'GA', text: 'Gabon'},
      {value: 'GM', text: 'Gambia'},
      {value: 'GE', text: 'Georgia'},
      {value: 'DE', text: 'Germany'},
      {value: 'GH', text: 'Ghana'},
      {value: 'GI', text: 'Gibraltar'},
      {value: 'GR', text: 'Greece'},
      {value: 'GL', text: 'Greenland'},
      {value: 'GD', text: 'Grenada'},
      {value: 'GP', text: 'Guadeloupe'},
      {value: 'GU', text: 'Guam'},
      {value: 'GT', text: 'Guatemala'},
      {value: 'GG', text: 'Guernsey'},
      {value: 'GN', text: 'Guinea'},
      {value: 'GW', text: 'Guinea-Bissau'},
      {value: 'GY', text: 'Guyana'},
      {value: 'HT', text: 'Haiti'},
      {value: 'HM', text: 'Heard Island & Mcdonald Islands'},
      {value: 'VA', text: 'Holy See (Vatican City State)'},
      {value: 'HN', text: 'Honduras'},
      {value: 'HK', text: 'Hong Kong'},
      {value: 'HU', text: 'Hungary'},
      {value: 'IS', text: 'Iceland'},
      {value: 'IN', text: 'India'},
      {value: 'ID', text: 'Indonesia'},
      {value: 'IR', text: 'Iran, Islamic Republic Of'},
      {value: 'IQ', text: 'Iraq'},
      {value: 'IE', text: 'Ireland'},
      {value: 'IM', text: 'Isle Of Man'},
      {value: 'IL', text: 'Israel'},
      {value: 'IT', text: 'Italy'},
      {value: 'JM', text: 'Jamaica'},
      {value: 'JP', text: 'Japan'},
      {value: 'JE', text: 'Jersey'},
      {value: 'JO', text: 'Jordan'},
      {value: 'KZ', text: 'Kazakhstan'},
      {value: 'KE', text: 'Kenya'},
      {value: 'KI', text: 'Kiribati'},
      {value: 'KR', text: 'Korea'},
      {value: 'KW', text: 'Kuwait'},
      {value: 'KG', text: 'Kyrgyzstan'},
      {value: 'LA', text: 'Lao People\'s Democratic Republic'},
      {value: 'LV', text: 'Latvia'},
      {value: 'LB', text: 'Lebanon'},
      {value: 'LS', text: 'Lesotho'},
      {value: 'LR', text: 'Liberia'},
      {value: 'LY', text: 'Libyan Arab Jamahiriya'},
      {value: 'LI', text: 'Liechtenstein'},
      {value: 'LT', text: 'Lithuania'},
      {value: 'LU', text: 'Luxembourg'},
      {value: 'MO', text: 'Macao'},
      {value: 'MK', text: 'Macedonia'},
      {value: 'MG', text: 'Madagascar'},
      {value: 'MW', text: 'Malawi'},
      {value: 'MY', text: 'Malaysia'},
      {value: 'MV', text: 'Maldives'},
      {value: 'ML', text: 'Mali'},
      {value: 'MT', text: 'Malta'},
      {value: 'MH', text: 'Marshall Islands'},
      {value: 'MQ', text: 'Martinique'},
      {value: 'MR', text: 'Mauritania'},
      {value: 'MU', text: 'Mauritius'},
      {value: 'YT', text: 'Mayotte'},
      {value: 'MX', text: 'Mexico'},
      {value: 'FM', text: 'Micronesia, Federated States Of'},
      {value: 'MD', text: 'Moldova'},
      {value: 'MC', text: 'Monaco'},
      {value: 'MN', text: 'Mongolia'},
      {value: 'ME', text: 'Montenegro'},
      {value: 'MS', text: 'Montserrat'},
      {value: 'MA', text: 'Morocco'},
      {value: 'MZ', text: 'Mozambique'},
      {value: 'MM', text: 'Myanmar'},
      {value: 'NA', text: 'Namibia'},
      {value: 'NR', text: 'Nauru'},
      {value: 'NP', text: 'Nepal'},
      {value: 'NL', text: 'Netherlands'},
      {value: 'AN', text: 'Netherlands Antilles'},
      {value: 'NC', text: 'New Caledonia'},
      {value: 'NZ', text: 'New Zealand'},
      {value: 'NI', text: 'Nicaragua'},
      {value: 'NE', text: 'Niger'},
      {value: 'NG', text: 'Nigeria'},
      {value: 'NU', text: 'Niue'},
      {value: 'NF', text: 'Norfolk Island'},
      {value: 'MP', text: 'Northern Mariana Islands'},
      {value: 'NO', text: 'Norway'},
      {value: 'OM', text: 'Oman'},
      {value: 'PK', text: 'Pakistan'},
      {value: 'PW', text: 'Palau'},
      {value: 'PS', text: 'Palestinian Territory, Occupied'},
      {value: 'PA', text: 'Panama'},
      {value: 'PG', text: 'Papua New Guinea'},
      {value: 'PY', text: 'Paraguay'},
      {value: 'PE', text: 'Peru'},
      {value: 'PH', text: 'Philippines'},
      {value: 'PN', text: 'Pitcairn'},
      {value: 'PL', text: 'Poland'},
      {value: 'PT', text: 'Portugal'},
      {value: 'PR', text: 'Puerto Rico'},
      {value: 'QA', text: 'Qatar'},
      {value: 'RE', text: 'Reunion'},
      {value: 'RO', text: 'Romania'},
      {value: 'RU', text: 'Russian Federation'},
      {value: 'RW', text: 'Rwanda'},
      {value: 'BL', text: 'Saint Barthelemy'},
      {value: 'SH', text: 'Saint Helena'},
      {value: 'KN', text: 'Saint Kitts And Nevis'},
      {value: 'LC', text: 'Saint Lucia'},
      {value: 'MF', text: 'Saint Martin'},
      {value: 'PM', text: 'Saint Pierre And Miquelon'},
      {value: 'VC', text: 'Saint Vincent And Grenadines'},
      {value: 'WS', text: 'Samoa'},
      {value: 'SM', text: 'San Marino'},
      {value: 'ST', text: 'Sao Tome And Principe'},
      {value: 'SA', text: 'Saudi Arabia'},
      {value: 'SN', text: 'Senegal'},
      {value: 'RS', text: 'Serbia'},
      {value: 'SC', text: 'Seychelles'},
      {value: 'SL', text: 'Sierra Leone'},
      {value: 'SG', text: 'Singapore'},
      {value: 'SK', text: 'Slovakia'},
      {value: 'SI', text: 'Slovenia'},
      {value: 'SB', text: 'Solomon Islands'},
      {value: 'SO', text: 'Somalia'},
      {value: 'ZA', text: 'South Africa'},
      {value: 'GS', text: 'South Georgia And Sandwich Isl.'},
      {value: 'ES', text: 'Spain'},
      {value: 'LK', text: 'Sri Lanka'},
      {value: 'SD', text: 'Sudan'},
      {value: 'SR', text: 'Suriname'},
      {value: 'SJ', text: 'Svalbard And Jan Mayen'},
      {value: 'SZ', text: 'Swaziland'},
      {value: 'SE', text: 'Sweden'},
      {value: 'CH', text: 'Switzerland'},
      {value: 'SY', text: 'Syrian Arab Republic'},
      {value: 'TW', text: 'Taiwan'},
      {value: 'TJ', text: 'Tajikistan'},
      {value: 'TZ', text: 'Tanzania'},
      {value: 'TH', text: 'Thailand'},
      {value: 'TL', text: 'Timor-Leste'},
      {value: 'TG', text: 'Togo'},
      {value: 'TK', text: 'Tokelau'},
      {value: 'TO', text: 'Tonga'},
      {value: 'TT', text: 'Trinidad And Tobago'},
      {value: 'TN', text: 'Tunisia'},
      {value: 'TR', text: 'Turkey'},
      {value: 'TM', text: 'Turkmenistan'},
      {value: 'TC', text: 'Turks And Caicos Islands'},
      {value: 'TV', text: 'Tuvalu'},
      {value: 'UG', text: 'Uganda'},
      {value: 'UA', text: 'Ukraine'},
      {value: 'AE', text: 'United Arab Emirates'},
      {value: 'GB', text: 'United Kingdom'},
      {value: 'US', text: 'United States'},
      {value: 'UM', text: 'United States Outlying Islands'},
      {value: 'UY', text: 'Uruguay'},
      {value: 'UZ', text: 'Uzbekistan'},
      {value: 'VU', text: 'Vanuatu'},
      {value: 'VE', text: 'Venezuela'},
      {value: 'VN', text: 'Viet Nam'},
      {value: 'VG', text: 'Virgin Islands, British'},
      {value: 'VI', text: 'Virgin Islands, U.S.'},
      {value: 'WF', text: 'Wallis And Futuna'},
      {value: 'EH', text: 'Western Sahara'},
      {value: 'YE', text: 'Yemen'},
      {value: 'ZM', text: 'Zambia'},
      {value: 'ZW', text: 'Zimbabwe'}
    ]
  },
  mutations: {
    setCoreLoaded(state, loaded) {
      state.coreLoaded = loaded;
    },
    fetchCurrentUser(state, data) {
      state.currentUser = data;
    },
    fetchUserTeams(state, data) {
      state.currentUserTeams = data;
      if (data && data.length && !data.map(x => x.team_id).includes(state.teamId)) {
        localStorage.setItem('selectedTeam', data[0].team_id);
        state.teamId = data[0].team_id;
      }
    },
    hideTutorial(state, data) {
        document.getElementById('worksends-right-sidebar').style.display = 'none';
    },
    switchTeamId(state, teamId) {
      state.teamId = parseInt(teamId);
      localStorage.setItem('selectedTeam', teamId);
    },
	showSidebar(state) {
		state.sidebarDisplayed = true;
	},
	hideSidebar(state) {
		state.sidebarDisplayed = false;
	},
	removeIDCardLoading() {
		document.querySelectorAll('[id=worksends-id-card]').forEach(function(item) {
			item.classList.remove('loading');
		});
	},
	sidebarShownChange(state, shown) {
		state.sidebarShown = shown;
	},
	openTutorialModal(state) {
		state.modals.marketplaceTutorialModal = true;
	},
	closeTutorialModal(state) {
		state.modals.marketplaceTutorialModal = false;
	}
  },
  actions: {
    async fetchCurrentUser(context) {
      try {
        let response = await api.get('/teams/'+context.state.teamId+'/current-user');
        context.commit('fetchCurrentUser', response.data);
        return response;
      } catch (e) { console.log(e); throw e; }
    },
    async fetchUserTeams(context) {
      try {
        let response = await api.get('/current-user/teams');
        if (response.data && response.data.length) context.commit('fetchUserTeams', response.data);
        else {
            await context.dispatch('onLogout');
            window.location.href = "/pro/login";
        }
        return response;
      } catch (e) { console.log(e); throw e; }
    },
    async sendContactForm(context, payload) {
		try {
			let response = await api.post('/public/emails/contact-form/send', payload);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
    async hideTutorial(context) {
        try {
			let response = await api.put('/teams/' + context.rootState.teamId + '/current-user', {show_tutorial: false});
			context.commit('hideTutorial', response);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	showSidebar(context) {
		context.commit('showSidebar');
	},
	hideSidebar(context) {
		context.commit('hideSidebar');
	},
	removeIDCardLoading(context) {
		context.commit('removeIDCardLoading');
	}
  },
  modules: {
    product,
    giftBoxCampaign,
    singleEventCampaign,
    team,
    term,
    transaction,
    paymentDocument,
    notification,
    login,
	resources,
	tutorials, 
    warehouse, 
    oms,
    ...surveys,
  }
})
